import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { useTextResources } from '../../../language';
import { useLocalStorageState } from '../../../hooks/useLocalStorageState';
import GridPanel from '../../../components/GridPanel';
import { onError, onWarning } from '../../../components/shared/messages';
import moment from 'moment';
import { GetIncomeReportData } from '../../../api/services/finance';
import { dateFormat } from '../../../components/shared/constants';

export const IncomeWidget = ({ HotelIds }) => {
  const text = useTextResources()
  const [state, setState] = useLocalStorageState("IncomeWidget", {
    days: 7
  })
  const [data, setData] = useState()

  const setDays = val => {
    setState(prev => {
      return {
        ...prev,
        days: val
      }
    })
  }

  useEffect(() => {
    (async () => {
      try {
        const data = await GetIncomeReportData(HotelIds.reduce((spec, val, idx) => {
          spec[`SelectedHotelIDs[${idx}]`] = val
          return spec
        }, {
          StartDate: moment().toISOString(),
          EndDate: moment().add(state.days, "days").toISOString()
        }))
        setData(data.map(x => {
          return {
            ...x,
            Income: x.AccommodationIncome + x.AddonIncome
          }
        }))
      } catch (error) {
        error.status === 400 ? onWarning(error) : onError(error)
      }
    })()
  }, [HotelIds, state.days])

  const dateFormatter = ({ value }) => {
    return value && moment(value).format(dateFormat)
  }
  const formatter = ({ value }) => {
    return value ? value.toFixed(2) : "0.00"
  }


  const gridOptions = {
    columns: [
      { name: 'Date', title: text("Date"), formatter: dateFormatter },
      { name: 'OccupancyPercent', title: text("Occupancy"), formatter: ({ value }) => `${value}%` },
      { name: 'NumberOfGuests', title: text("Guests") },
      { name: 'Income', title: text("Income"), formatter }
    ],
    columnExtensions: [
      { columnName: 'Date', width: 150 },
      { columnName: 'OccupancyPercent', width: 150 },
      { columnName: 'NumberOfGuests', width: 100 },
      { columnName: 'Income', width: 100 },
    ],
    summary: true,
    totalSummaryItems: [
      { columnName: 'Income', type: 'sum', formatter }
    ]
  }

  return <div style={{ display: "flex", overflow: "hidden", flexDirection: "column", height: "100%" }}>
    <Button.Group fluid widths='3'>
      <Button primary={state.days === 7} onClick={() => setDays(7)}>7 {text("Days")}</Button>
      <Button primary={state.days === 14} onClick={() => setDays(14)}>14 {text("Days")}</Button>
      <Button primary={state.days === 30} onClick={() => setDays(30)}>30 {text("Days")}</Button>
    </Button.Group>
    <div style={{ flex: 1, display: "flex", overflow: "hidden",overflowX: "auto" }}>
      <GridPanel options={gridOptions} data={data} />
    </div>
  </div>;
};

IncomeWidget.propTypes = {
  HotelIds: PropTypes.array,
};
